module.exports = __webpack_public_path__ + "static/img/ad9.48ea049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad9.png
// module id = tKgd
// module chunks = 12